// Note Template Categories
export const NOTE_TEMPLATE_CATEGORIES = [
    { value: 0, label: 'Angebot' },
    { value: 1, label: 'Auftragsbestätigung' },
    { value: 2, label: 'Rechnung' },
    { value: 3, label: 'Notiz-Artikel' },
    { value: 4, label: 'Notizen' },
    { value: 5, label: 'Workflow' },
    { value: 6, label: 'Kontakt' },
    { value: 7, label: 'Job' },
    { value: 8, label: 'Hochzeit' },
    { value: 9, label: 'Location' },
    { value: 10, label: 'Aufgaben' },
    { value: 11, label: 'Widersprucherklärung' }
];

// Get category label by value
export const getCategoryLabel = (value) => {
    const category = NOTE_TEMPLATE_CATEGORIES.find(c => c.value === parseInt(value));
    return category ? category.label : '';
};

// Get category value by label
export const getCategoryValue = (label) => {
    const category = NOTE_TEMPLATE_CATEGORIES.find(c => c.label === label);
    return category ? category.value : null;
};
